export const getStyles = (_, { palette = {} } = {}) => {
  const doubleListBox = {
    '& > div': {
      height: 470,
    },
    '& .items .item[aria-selected="true"]': {
      backgroundColor: palette.neutralLight,

      '& div:nth-child(2)': {
        display: 'none',
      },
    },
  };

  return {
    doubleListBox,
  };
};
